import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import cloneDeep from 'lodash.clonedeep';
import { Row, Col, Button, Badge, Nav, NavItem, NavLink,
  Modal, ModalBody, ModalFooter,
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Media, Tooltip } from 'reactstrap';
import { FaEllipsisH, FaGripHorizontal, FaVial, FaVials, FaUsers,
  FaCube, FaPeopleCarry, FaFilter } from 'react-icons/fa';
import Slider from 'rc-slider';
import RichScatterPlot from '../Charts/RichScatterPlot.jsx';
import MapsAnalysisDialog from '../Dialogs/MapsAnalysisDialog';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);

class DetailPanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      showTooltipOrganism: false,
      showTooltipTeam: false,
      isOpenMoreMaps: false,
      isOpenMoreRelations: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    //this.updateBackgroundInfo(nextProps)
    if(nextProps.category === 'organism')
      this.updateCurrentOrganismInfo(nextProps)
    else if(nextProps.category === 'team')
      this.updateCurrentTeamInfo(nextProps)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextState !== this.state)
      return true;
    if(nextProps.filterTimeStamp !== this.props.filterTimeStamp)
      return true;
    if(nextProps.category === this.props.category){
      if(nextProps.category === 'organism' &&
        this.showingDetail === this.currentOrganism &&
        nextProps.organismIndex === this.props.organismIndex)
        return false
      else if(nextProps.category === 'team' &&
        this.showingDetail === this.currentTeam &&
        nextProps.teamIndex === this.props.teamIndex)
        return false
    }
    return true
  }

  selectSubset = (currentItem => {
    if(this.props.category === 'organism')
      this.props.onOrganismSelected(currentItem);
    else if(this.props.category === 'team')
      this.props.onTeamSelected(currentItem);
  }).bind(this);

  toggleMoreMaps = (() => {
    this.setState({ isOpenMoreMaps: !this.state.isOpenMoreMaps,
      showRelationGraph: false });
  }).bind(this);

  toggleMoreRelations = (() => {
    this.setState({ isOpenMoreRelations: !this.state.isOpenMoreRelations });
  }).bind(this);

  updateBackgroundInfo(props) {
    if(!props.base || !props.filtered)
      return;
    let {
      dataListEMDs,
    } = props.base;
    let {
      filterMap,
      filterResults,
    } = props.filtered;
    if(!dataListEMDs) dataListEMDs = [];

    if(filterResults) {
      this.backgroundData = {
        name: 'All',
        data: dataListEMDs.map((d, di) => (filterMap[di] && d.t.getTime() > 0) ? [d.t, d.r, d.g, d.n, di] : undefined)
          .filter(d => d).sort((a,b) => a[0].getTime()-b[0].getTime()),
      }
    }
    else this.backgroundData = {};
  }

  updateCurrentOrganismInfo(props) {
    if(!props.base || !props.filtered)
      return;
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterMap,
      filterOrganisms,
    } = props.filtered;
    let {
      organismIndex,
    } = props;
    if(!dataListEMDs) dataListEMDs = [];
    if(!filterOrganisms) filterOrganisms = [];

    this.currentOrganism = undefined;
    if(filterOrganisms.length && filterOrganisms[organismIndex]) {
      this.currentOrganism = cloneDeep(filterOrganisms[organismIndex]);
      this.timelineData = listEMMethod.map((m, mi) => ({
        name: m.name,
        symbolSize: 1,
        data: dataListEMDs.map((d, di) => (filterMap[di] && d.o.indexOf(this.currentOrganism.id) >= 0 && d.m === mi && d.t.getTime() > 0) ? [d.t, d.r, d.g, d.n, di] : undefined)
          .filter(d => d).sort((a,b) => a[0].getTime()-b[0].getTime()),
      }));
      //this.timelineData.push(this.backgroundData);
      this.currentOrganism.maps = this.timelineData.map(td => td.data.map(d => ({name: d[3], index: d[4], time: d[0].getTime()})))
        .reduce((a,b) => a.concat(b)).sort((a,b) => a.time-b.time);
      let filterOrganismsMap = [];
      filterOrganisms.forEach((t, tidx) => {
        filterOrganismsMap[t.id] = tidx;
      })
      this.currentOrganism.relations = this.currentOrganism.parents ? this.currentOrganism.parents
        .map(p => filterOrganismsMap[p] && ({
          name: filterOrganisms[filterOrganismsMap[p]].name,
          index: filterOrganismsMap[p]
        })).filter(r => r) : [];
      this.currentOrganism.relations = this.currentOrganism.relations.concat(this.currentOrganism.children ? this.currentOrganism.children
        .map(p => filterOrganismsMap[p] && ({
          name: filterOrganisms[filterOrganismsMap[p]].name,
          index: filterOrganismsMap[p]
        })).filter(r => r) : []);
    }
    else this.timelineData = []
    this.timelineDataInfo = [
        {name: 'date', index: 0, text: 'Release date'},
        {name: 'reso', index: 1, text: 'Resolution'},
        {name: 'grid', index: 2, text: 'Number of grid points'},
    ];
  }

  updateCurrentTeamInfo(props) {
    if(!props.base || !props.filtered)
      return;
    let {
      listEMMethod,
      dataListEMDs,
    } = props.base;
    let {
      filterMap,
      filterTeams,
    } = props.filtered;
    let {
      teamIndex,
    } = props;
    if(!dataListEMDs) dataListEMDs = [];
    if(!filterTeams) filterTeams = [];

    this.currentTeam = undefined;
    if(filterTeams.length && filterTeams[teamIndex]) {
      this.currentTeam = cloneDeep(filterTeams[teamIndex]);
      this.timelineData = listEMMethod.map((m, mi) => ({
        name: m.name,
        symbolSize: 1,
        data: dataListEMDs.map((d, di) => (filterMap[di] && d.u.indexOf(this.currentTeam.id) >= 0 && d.m === mi && d.t.getTime() > 0) ? [d.t, d.r, d.g, d.n, di] : undefined)
          .filter(d => d).sort((a,b) => a[0].getTime()-b[0].getTime()),
      }));
      //this.timelineData.push(this.backgroundData);
      this.currentTeam.maps = this.timelineData.map(td => td.data.map(d => ({name: d[3], index: d[4], time: d[0].getTime()})))
        .reduce((a,b) => a.concat(b)).sort((a,b) => a.time-b.time);
      let filterTeamsMap = [];
      filterTeams.forEach((t, tidx) => {
        filterTeamsMap[t.id] = tidx;
      })
      this.currentTeam.relations = this.currentTeam.parents ? this.currentTeam.parents
        .map(p => filterTeamsMap[p] && ({
          name: filterTeams[filterTeamsMap[p]].name,
          index: filterTeamsMap[p]
        })).filter(r => r) : [];
      this.currentTeam.relations = this.currentTeam.relations.concat(this.currentTeam.children ? this.currentTeam.children
        .map(p => filterTeamsMap[p] && ({
          name: filterTeams[filterTeamsMap[p]].name,
          index: filterTeamsMap[p]
        })).filter(r => r) : []);
    }
    else this.timelineData = []
    this.timelineDataInfo = [
        {name: 'date', index: 0, text: 'Release date'},
        {name: 'reso', index: 1, text: 'Resolution'},
        {name: 'grid', index: 2, text: 'Number of grid points'},
    ];
  }

  renderCategoryToggle() {
    return (
      <Nav pills style={{ display: 'flex', 'justify-content': 'flex-end' }}>
        <NavItem>
          <NavLink
            id='item-organism'
            className={classnames({ active: this.props.category === 'organism', handcursor: true })}
            onClick={() => { this.props.toggleCategory('organism'); }}
          >
            <h4><FaVial /></h4>
          </NavLink>
        </NavItem>
        <Tooltip
          placement="bottom"
          isOpen={this.state.showTooltipOrganism}
          target="item-organism"
          toggle={(() => this.setState({showTooltipOrganism: !this.state.showTooltipOrganism})).bind(this)}
        >Organism</Tooltip>
        <NavItem>
          <NavLink
            id='item-team'
            className={classnames({ active: this.props.category === 'team', handcursor: true })}
            onClick={() => { this.props.toggleCategory('team'); }}
          >
            <h4><FaUsers /></h4>
          </NavLink>
        </NavItem>
        <Tooltip
          placement="bottom"
          isOpen={this.state.showTooltipTeam}
          target="item-team"
          toggle={(() => this.setState({showTooltipTeam: !this.state.showTooltipTeam})).bind(this)}
        >Author</Tooltip>
      </Nav>
    )
  }

  renderEMDList_0(maps) {
    return (<div>
      <FaCube size='1.2em' /> {maps.slice(0, 9).map(d => (
        <Button className='emdbadge' size='sm' onClick={() => this.props.onEMDSelected(d.index)}>{d.name.slice(4, 10)}</Button>
      ))}
      {(maps.length > 9) && (
        <ButtonDropdown className='emdbadge' isOpen={this.state.isOpenMoreMaps} toggle={this.toggleMoreMaps}>
          <DropdownToggle caret size="sm">
            <FaEllipsisH />
          </DropdownToggle>
          <DropdownMenu>
            {maps.slice(9).map(d => (
              <DropdownItem onClick={() => this.props.onEMDSelected(d.index)}>{d.name}</DropdownItem>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      )}
    </div>);
  }

  renderEMDList(maps) {
    return (<div>
      <FaCube size='1.2em' /> {maps.slice(0, 9).map(d => (
        <Button className='emdbadge' size='sm' onClick={() => this.props.onEMDSelected(d.index)}>{d.name.slice(4, 10)}</Button>
      ))}
      <Button className='emdbadge' size='sm' onClick={this.props.onMapAnalyze ? (() => this.props.onMapAnalyze(maps.map(m => m.index))) : this.toggleMoreMaps}><FaGripHorizontal /></Button>
      {this.state.isOpenMoreMaps && <MapsAnalysisDialog
        base={this.props.base}
        maps={maps.map(m => m.index)}
        toggle={this.toggleMoreMaps}
        onEMDSelected={this.props.onEMDSelected}
        onDrill={this.props.onDrill}
      />}
    </div>);
  }

  renderRelations(icon, relations) {
    return (<div>
      {(relations && relations.length) ? (<div>{icon} {relations.slice(0, 2).map(d => (
        <Button className='emdbadge' size='sm' onClick={() => this.selectSubset(d.index)}>{d.name}</Button>
      ))}
      {(relations.length > 2) && (
        <ButtonDropdown className='emdbadge' isOpen={this.state.isOpenMoreRelations} toggle={this.toggleMoreRelations}>
          <DropdownToggle caret size="sm">
            <FaEllipsisH />
          </DropdownToggle>
          <DropdownMenu>
            {relations.slice(2).map(d => (
              <DropdownItem onClick={() => this.selectSubset(d.index)}>{d.name}</DropdownItem>
            ))}
          </DropdownMenu>
        </ButtonDropdown>
      )}</div>) : ''}
    </div>);
  }

  renderForOrganism() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    this.showingDetail = this.currentOrganism;
    return this.currentOrganism ? <div>
      <Media body>
        <Row>
          <Col sm={9}>
            <Media heading>
              <FaVial size='1.2em' />{` ${this.currentOrganism.name} (${this.currentOrganism.ncbi}) `}
              <sub><small>
              <Badge className='handcursor' color="success" onClick={this.props.onOrganismDrilled}><FaFilter /> Filter</Badge>
              </small></sub>
            </Media>
          </Col>
          <Col sm={3}>
            {this.renderCategoryToggle()}
          </Col>
        </Row>
        {this.renderEMDList(this.currentOrganism.maps)}
        {this.renderRelations(<FaVials size='1.2em' />, this.currentOrganism.relations)}
      </Media>
      <RichScatterPlot
        width={600 * sizeFactor}
        height={400 * sizeFactor}
        schema={this.timelineDataInfo}
        data={this.timelineData}
        onSelected={this.props.onEMDSelected}
        sizeFactor={sizeFactor}
      />
    </div> : <div />
  }

  renderForTeam() {
    let {sizeFactor} = this.props;
    if(!sizeFactor) sizeFactor = 1;
    this.showingDetail = this.currentTeam;
    return this.currentTeam ? <div>
      <Media body>
        <Row>
          <Col sm={6}>
            <Media heading>
              <FaUsers size='1.2em' />{` ${this.currentTeam.name} `}
              <sub><small>
              <Badge className='handcursor' color="success" onClick={this.props.onTeamDrilled}><FaFilter /> Filter</Badge>
              </small></sub>
            </Media>
          </Col>
          <Col sm={6}>
            {this.renderCategoryToggle()}
          </Col>
        </Row>
        {this.renderEMDList(this.currentTeam.maps)}
        {this.renderRelations(<FaPeopleCarry size='1.2em' />, this.currentTeam.relations)}
      </Media>
      <RichScatterPlot
        width={600 * sizeFactor}
        height={400 * sizeFactor}
        schema={this.timelineDataInfo}
        data={this.timelineData}
        onSelected={this.props.onEMDSelected}
        sizeFactor={sizeFactor}
      />
    </div> : <div />
  }

  render() {
    if(this.props.category === 'organism')
      return this.renderForOrganism();
    else if(this.props.category === 'team')
      return this.renderForTeam();
  }
}

DetailPanel.propTypes = {
  listEMMethod: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  })),
  dataListEMDs: PropTypes.arrayOf(PropTypes.shape({
    m: PropTypes.number.isRequired,
    c: PropTypes.arrayOf(PropTypes.number).isRequired,
    o: PropTypes.arrayOf(PropTypes.number).isRequired,
    a: PropTypes.arrayOf(PropTypes.number).isRequired,
    u: PropTypes.arrayOf(PropTypes.number).isRequired,
    s: PropTypes.number.isRequired,
    p: PropTypes.number.isRequired,
    r: PropTypes.number.isRequired,
    t: PropTypes.instanceOf(Date).isRequired,
    g: PropTypes.number.isRequired,
  })),
}

export default DetailPanel;
